import {createSlice} from '@reduxjs/toolkit';

export const formsAdditionalHelperSlice = createSlice({
    name: 'forms',
    initialState: {
        obsFromForms: false,
        obsIdToFormAdd: null,
    },
    reducers: {
        setObsFromForms: (state, type) => {
            state.obsFromForms = type.payload;
        },
        setObsIdToFormAdd: (state, type) => {
            state.obsIdToFormAdd = type.payload;
        },
    },
});

// Setters
export const {
    setObsFromForms,
    setObsIdToFormAdd,
} = formsAdditionalHelperSlice.actions;

// Variable
export const obsFromForms = (state) => state.forms.obsFromForms;
export const obsIdToFormAdd = (state) => state.forms.obsIdToFormAdd;

export default formsAdditionalHelperSlice.reducer;

